module.exports = __webpack_public_path__ + "static/media/lecturer2.1f2fd027.jpg";